import React from "react";
import styled from "@emotion/styled";
import MediaQuery from "react-responsive";

const Kv = styled.div`
  width: 100%;
  height: 100vh;
  background-image: url(${props=>props.bg});
  background-size: cover;
  background-position: center;
`;

const Mobile = styled.div`
  width: 100%;
  img {
    width: 100%;
  }
`;


const Temporarily = ({img}) => {
  return (
    <>
      <MediaQuery minWidth={1024}>
        <Kv bg={img}/>
      </MediaQuery>
      <MediaQuery maxWidth={1023}>
        <Mobile>
          <img src={img} alt=""/>
        </Mobile>
      </MediaQuery>
    </>
  )
};

export default Temporarily;